//TODO: This is a duplicate of utilities because of logger referring to shared components, it should be cleaned up
// once we move the logger to utilities.

// Helper methods for user provider.
import jwt_decode from 'jwt-decode';

interface TokenParams {
  userid: string;
}

const getUserIdFromToken = (accessToken: string) => {
  const decodedToken: TokenParams = jwt_decode(accessToken);
  return decodedToken.userid;
};

export default getUserIdFromToken;
